export abstract class AbstractFormField {
  label?: string;
}
